var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _c("h3", { staticClass: "section-font-size text-center" }, [
          _vm._v(_vm._s(_vm.T.problemEditAddTags))
        ]),
        _vm._l(_vm.tags, function(tag, index) {
          return _c("div", { key: index, staticClass: "form-check" }, [
            _c("label", { staticClass: "form-check-label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentSelectedTags,
                    expression: "currentSelectedTags"
                  }
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox" },
                domProps: {
                  value: tag.name,
                  checked: Array.isArray(_vm.currentSelectedTags)
                    ? _vm._i(_vm.currentSelectedTags, tag.name) > -1
                    : _vm.currentSelectedTags
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.currentSelectedTags,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = tag.name,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.currentSelectedTags = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.currentSelectedTags = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.currentSelectedTags = $$c
                    }
                  }
                }
              }),
              _vm._v(
                _vm._s(_vm.T[tag.name] + " (" + tag.problemCount + ")") + " "
              )
            ])
          ])
        }),
        _c(
          "div",
          { staticClass: "form-group mt-2" },
          [
            _c("vue-typeahead-bootstrap", {
              attrs: {
                data: _vm.publicQualityTagNames,
                serializer: _vm.publicQualityTagsSerializer,
                placeholder: _vm.T.collecionOtherTags
              },
              on: { hit: _vm.addOtherTag }
            })
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }